const WATERMARK_DISMISSED_STORAGE_KEY = 'vibe-full-page:watermark-dismissed';

const getDismissedStorageKey = (aiAppId: string | undefined) =>
  aiAppId ? `${WATERMARK_DISMISSED_STORAGE_KEY}:${aiAppId}` : WATERMARK_DISMISSED_STORAGE_KEY;

export const readWatermarkDismissed = (aiAppId: string | undefined): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(getDismissedStorageKey(aiAppId)) === 'true';
  } catch {
    return false;
  }
};

export const persistWatermarkDismissed = (aiAppId: string | undefined): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(getDismissedStorageKey(aiAppId), 'true');
  } catch {}
};
